// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"12cec6e2","99":"698a0afa","104":"f941701d","310":"c9fb664d","358":"a4892f8a","637":"04aa54d6"}[chunkId] + ".css";
};